import { type Ref, ref, watchEffect } from 'vue'
import { useFloating, offset, flip, shift, autoUpdate } from '@floating-ui/vue'

export function useFloatingUI(referenceEl: Ref<HTMLElement | null>) {
  const floatingEl = ref<HTMLElement | null>(null)

  const { floatingStyles } = useFloating(referenceEl, floatingEl, {
    placement: 'bottom-end',
    middleware: [
      offset(12), // 0.75rem margin-top
      flip({
        fallbackPlacements: ['bottom-start', 'top-end', 'top-start'],
        padding: 8,
      }),
      shift({
        padding: 8,
      }),
    ],
    whileElementsMounted: autoUpdate,
  })

  return {
    floatingEl,
    floatingStyles,
  }
}
